import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { AskPanel } from "./AskPanel";

/**
 * AskLauncher — floating bottom-right button that opens a slide-in AskPanel.
 * Mounted once inside DashboardLayout so it's available on every module.
 * Auto-hides on the dedicated /app/ask page (that page already shows the same panel).
 */
export const AskLauncher = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  if (pathname.startsWith("/app/ask")) return null;

  return (
    <>
      {!open && (
        <button
          type="button"
          data-testid="btn-ask-open"
          onClick={() => setOpen(true)}
          className="fixed z-40 flex items-center gap-2 rounded-full transition-transform hover:scale-[1.04]"
          style={{
            bottom: 20,
            right: 20,
            padding: "12px 18px",
            background: "linear-gradient(135deg, #00B4D8 0%, #7C6FF0 100%)",
            color: "#FFFFFF",
            boxShadow: "0 10px 24px rgba(0,180,216,0.35), 0 4px 8px rgba(20,20,43,0.20)",
          }}
          aria-label="Ask about the data"
        >
          <Sparkles size={16} strokeWidth={2.4} />
          <span className="text-[12px] font-bold uppercase tracking-widest">Ask</span>
        </button>
      )}

      {open && (
        <>
          {/* Backdrop — mobile-only */}
          <div
            className="fixed inset-0 z-40 bg-black/40 lg:hidden"
            onClick={() => setOpen(false)}
            data-testid="ask-backdrop"
          />
          {/* Slide-in panel */}
          <aside
            className="fixed top-0 right-0 h-screen z-50 flex flex-col shadow-2xl transition-transform"
            style={{
              width: "min(420px, 100vw)",
              background: "#F5F6FA",
            }}
            data-testid="ask-drawer"
          >
            <AskPanel variant="drawer" onClose={() => setOpen(false)} />
          </aside>
        </>
      )}
    </>
  );
};

export default AskLauncher;
